import { render, staticRenderFns } from "./story_file_drop.vue?vue&type=template&id=491631f2&lang=pug"
import script from "./story_file_drop.vue?vue&type=script&lang=js"
export * from "./story_file_drop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports